export default __webpack_public_path__ + "static/CentraNo2-BookItalic-a17171a5510e39541ac10ed01719aeb1.woff2";